// components
import SelectedNavTags from './selected-tags';
import { FilterNavProps } from './types';

// styles
import styles from './tags-list.module.css';

export default function TagsList({
  tags,
  filters,
  foundedEntriesForTags,
  onFilterChange,
  lists,
  onClearAutoComplete,
  hiddenFiltersTags,
  filtersLists,
  setFiltersList,
}: FilterNavProps): React.JSX.Element {
  return (
    <div className={styles.tagsList}>
      <SelectedNavTags
        tags={tags}
        lists={lists}
        filters={filters}
        onFilterChange={onFilterChange}
        foundedEntriesForTags={foundedEntriesForTags}
        onClearAutoComplete={onClearAutoComplete}
        hiddenFiltersTags={hiddenFiltersTags}
        filtersLists={filtersLists}
        setFiltersList={setFiltersList}
      />
    </div>
  );
}
